import NavList from '../NavList';
import { INavigationItem } from '../../types';
import { useEffect, useState } from 'react';
import { useUserStore } from "../../../User/store";
import { Link } from "react-router-dom";

const baseNavigation: INavigationItem[] = [
  {
    displayName: 'База одежды',
    name: 'clothes',
    path: '/',
    visible: true,
  },
  {
    displayName: 'Логирование',
    name: 'logs',
    path: '/logs',
    visible: true,
  },
  {
    displayName: 'Пользователи',
    name: 'users',
    path: '/users',
    visible: true,
  },
  {
    displayName: 'Оценки образов',
    name: 'feedback',
    path: '/feedback',
    visible: true,
  },
  {
    displayName: 'Оценки переодеваний',
    name: 'feedbackfitting',
    path: '/feedbackfitting',
    visible: true,
  },
    {
        displayName: 'Оценки перс. бокса',
        name: 'feedbackPersonalCapsule',
        path: '/feedbackPersonalCapsule',
        visible: true,
    },
  {
    displayName: 'Персональный бокс',
    name: 'personalCapsule',
    path: '/personalCapsuleList',
    visible: true,
  }
];

export default function Navigation() {
  const userData = useUserStore((state) => state.userData);
  const getCurrentUserData = useUserStore((state) => state.getCurrentUserData);
  const [filteredNavigation, setFilteredNavigation] = useState<INavigationItem[]>(baseNavigation);

  const filterNavigationByPermissions = () => {
    if (!userData) return baseNavigation;

    return baseNavigation.filter(item => {

      if (userData.role === "admin") return true;

      if (userData.role != "customer") {

        return userData.permissions.includes(item.name);
      }

      return false;
    });
  };

  useEffect(() => {
    getCurrentUserData();
  }, [getCurrentUserData]);

  useEffect(() => {
    if (userData) {
      const filtered = filterNavigationByPermissions();
      setFilteredNavigation(filtered);
    }
  }, [userData]);

  return (
      <nav>
        <NavList navItems={filteredNavigation} />
      </nav>
  );
}